export const VIEW_TYPE = {
    PC: "pc",
    WEB: "web",
    MAC: "mac",
    ANDROID: "android",
    IOS: "ios"
}

export const WEB_BROWSER = {
    NONE: "none",
    CHROME: "chrome",
    SAFARI: "safari"
}